module.exports = __webpack_public_path__ + "static/media/chess-knight-alt.b15993d8.svg";